import { Card, Skeleton, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import TicketByStatus from "./TicketByStatus";
import TicketByMonth from "./TicketByMonth";
import BugByMonth from "./BugByMonth";
import AssigneeTimeLog from "./AssigneeTimeLog";
import AssigneeAvgTimeLog from "./AssigneeAvgTimeLog";
import TicketByGroup from "./TicketByGroup";
import BugByProject from "./BugByProject";
import TicketByProject from "./TicketByProject";
import TicketByAge from "./TicketByAge";
import { columnChartConfigurationOptions } from "../../config";

import "./JiraDashboard.css";

const { TabPane } = Tabs;
const barChartOptions = {
    isStacked: true,
    ...columnChartConfigurationOptions,
};

function JiraDashboard() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const navigate = useNavigate();
    const { selectedDates } = useContext(SettingContext);
    const [assignees_tickets, setAssigneesTickets] = useState([]);
    const [priorities, setPriorities] = useState([]);
    const [projectOptions, setProjectOptions] = useState([]);

    useEffect(() => {
        async function fatch() {
            const { data: jiraProjects } = await HTTP(
                "/analytics/getJiraProjects",
                {
                    staff_id,
                },
            );
            setProjectOptions(jiraProjects);
            const start_date = formatDate(selectedDates[0]);
            const end_date = formatDate(selectedDates[1]);
            const formData = {
                staff_id,
                start_date,
                end_date,
            };
            const { data: jiraData } = await HTTP(
                "/analytics/getJiraDashboard",
                formData,
            );

            const { assignees_tickets, priorities } = jiraData;

            setAssigneesTickets(assignees_tickets);
            setPriorities(priorities);
        }
        fatch();
    }, []);

    function renderToTable(e) {
        const priority_id = e.target.getAttribute("id");
        if (priority_id)
            navigate(`/jira-dashboard/priority-tickets/${priority_id}`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <div className="dashboard-jira-container">
                <Card className="box-shadow margin-10">
                    <div className="ticket-types">
                        {priorities.length > 0 ? (
                            priorities.map((e) => {
                                {
                                    if (e.priority.trim() !== "") {
                                        return (
                                            <div
                                                key={e.priority_id}
                                                id={e.priority_id}
                                                className="ticket-type-stapper"
                                                onClick={renderToTable}
                                            >
                                                <span className="tickets-type">
                                                    {e.priority}
                                                </span>
                                                <span className="no-of-tickets">{`${e.openTickets} / ${e.tickets}`}</span>
                                            </div>
                                        );
                                    }
                                    return 0;
                                }
                            })
                        ) : (
                            <Skeleton
                                active={true}
                                title={false}
                                paragraph={{ rows: 3 }}
                            />
                        )}
                    </div>
                </Card>
                <Card className="box-shadow margin-10">
                    <Tabs type="card" destroyInactiveTabPane={true}>
                        <TabPane key={1} tab="WorkLogs and Tickets By Months">
                            <Card className="chartCard chartWithDatePicker">
                                <AssigneeTimeLog projects={projectOptions} />
                            </Card>
                        </TabPane>
                        <TabPane key={2} tab="Bugs By Project">
                            <Card className="chartCard chartWithDatePicker">
                                <BugByProject />
                            </Card>
                        </TabPane>
                        <TabPane key={3} tab="Average Worklog By Month">
                            <Card className="chartCard chartWithDatePicker">
                                <AssigneeAvgTimeLog projects={projectOptions} />
                            </Card>
                        </TabPane>
                        <TabPane key={4} tab="Tickets By Group">
                            <Card className="chartCard chartWithDatePicker">
                                <TicketByGroup projects={projectOptions} />
                            </Card>
                        </TabPane>
                        <TabPane key={5} tab="Tickets By Assignee">
                            <Card className="chartCard">
                                {assignees_tickets.length > 0 ? (
                                    <Chart
                                        className="charts"
                                        chartType="BarChart"
                                        legendToggle
                                        height="150vh"
                                        options={{
                                            ...barChartOptions,
                                            title: "Tickets By Assignee",
                                        }}
                                        data={assignees_tickets}
                                    />
                                ) : (
                                    <Skeleton />
                                )}
                            </Card>
                        </TabPane>
                        <TabPane key={6} tab="Tickets By Project">
                            <Card className="chartCard chartWithDatePicker">
                                <TicketByProject projects={projectOptions} />
                            </Card>
                        </TabPane>
                        <TabPane key={7} tab="Tickets By Months">
                            <Card className="chartCard chartWithDatePicker">
                                <TicketByMonth projects={projectOptions} />
                            </Card>
                        </TabPane>
                        <TabPane key={8} tab="Bugs By Months">
                            <Card className="chartCard chartWithDatePicker">
                                <BugByMonth
                                    barChartOption={barChartOptions}
                                    projects={projectOptions}
                                />
                            </Card>
                        </TabPane>
                        <TabPane key={9} tab="Tickets By Age">
                            <Card className="chartCard chartWithDatePicker">
                                <TicketByAge projects={projectOptions} />
                            </Card>
                        </TabPane>
                        <TabPane key={10} tab="Tickets By Status">
                            <Card className="chartCard chartWithDatePicker">
                                <TicketByStatus projects={projectOptions} />
                            </Card>
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        </Card>
    );
}

export { JiraDashboard };
